import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import request from '../utils/request';
import Layout from '../components/Layout';
import './MyRegistrations.css';

function MyRegistrations() {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRegistrations();
  }, []);

  const fetchRegistrations = async () => {
    try {
      const res = await request({
        url: '/api/activity/my',
        method: 'GET'
      });
      setRegistrations(res.data);
    } catch (err) {
      console.error('获取报名列表失败:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatPrice = (price) => {
    return `¥${(price / 100).toFixed(2)}`;
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString('zh-CN', {
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <Layout>
        <div className="container">加载中...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="container">
        <div className="header">
          <h2>📋 我的报名</h2>
        </div>

      {registrations.length === 0 ? (
        <div className="empty-state">
          <p>暂无报名记录</p>
          <button 
            className="btn btn-primary"
            onClick={() => navigate('/activities')}
            style={{ marginTop: 16 }}
          >
            浏览活动
          </button>
        </div>
      ) : (
        <div className="registration-list">
          {registrations.map(reg => (
            <div key={reg.id} className="registration-card">
              <div className="card-header">
                <h3>{reg.title}</h3>
                <span className={`status-badge ${reg.status}`}>
                  {reg.status === 'paid' ? '已支付' : '待支付'}
                </span>
              </div>
              
              <div className="card-body">
                <div className="info-line">
                  <span className="label">活动时间：</span>
                  <span>{formatDate(reg.start_time)}</span>
                </div>
                
                <div className="info-line">
                  <span className="label">活动地点：</span>
                  <span>{reg.location_name}</span>
                </div>
                
                <div className="info-line">
                  <span className="label">支付金额：</span>
                  <span className="price">{formatPrice(reg.final_price)}</span>
                </div>
                
                {reg.location_sent === 1 && (
                  <div className="info-line location-sent">
                    <span className="label">📍 活动地址已发送</span>
                  </div>
                )}
              </div>
              
              <div className="card-footer">
                <button 
                  className="btn btn-text"
                  onClick={() => navigate(`/activity/${reg.activity_id}`)}
                >
                  查看详情
                </button>
                {reg.status === 'pending' && (
                  <button 
                    className="btn btn-primary"
                    onClick={() => navigate(`/activity/${reg.activity_id}`)}
                  >
                    去支付
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      </div>
    </Layout>
  );
}

export default MyRegistrations;